export enum ActivityType {
    NONE = 0,
    COMPETITION = 1,
    TEAMS = 2,
    TOURNAMENT = 3,
    VUGRAPH = 4,
    COURSE = 5,
}